export default "__VITE_ASSET__TpOkAknF__"